module.exports = __webpack_public_path__ + "static/media/Jesica,22@2x.ed05ee9f.png";